import GameStepBase from '../../game_step_base';
import GameNavigationBarComponentController from '../../../../../components/game_navigation_bar/game_navigation_bar_component_controller';
import _ from '../../../../../utils/underscore';

export default class BuildNavigationBarGameStep extends GameStepBase {
    static CLASS = 'BuildNavigationBarGameStep';

    _isReal: boolean;
    _showFreePlaySelection: boolean = true;

    init(params) {
        super.init(params);
        this._isReal = params.isReal;
        if (_.isBoolean(params.showFreePlaySelection)) {
            this._showFreePlaySelection = params.showFreePlaySelection;
        }
    }

    run(gameOptions) {
        const navigationBar = this.serviceFactory.componentFactoryService().createComponent(GameNavigationBarComponentController, {
            isReal: this._isReal,
            gameType: gameOptions.gameType,
            gameName: gameOptions.gameName,
            showAge: this._showAgeResponsibleIconInGame(),
            marketing: gameOptions.marketing,
            freePlayData: gameOptions.freePlayData,
            referrerId: gameOptions.referrerId,
            showGameModeToggle: this._shouldShowGameModeToggle(gameOptions),
            loginProperties: this._extractGameNavbarLoginProps(gameOptions),
            showFreePlaySelection: this._showFreePlaySelection
        });

        return Promise.resolve(Object.assign(gameOptions, {
            gameNavigationBar: navigationBar
        }));
    }

    _showAgeResponsibleIconInGame() {
        return this.serviceFactory.regulationService().getRegulation().showAgeResponsibleIconInGame();
    }

    private _shouldShowGameModeToggle(gameOptions) {
        // if in SDM isAnonymousSupported is false then this is all that matters
        if(!gameOptions.gameInfo.isAnonymousSupported) {
            return false;
        }

        if(!gameOptions.company.allowDemoForGame(gameOptions.gameInfo)) {
            return false;
        }

        if(this.serviceFactory.regulationService().forceDemoButton()) {
            return true;
        }

        let allowSwitchGameMode: boolean = gameOptions.gameInfo.isAnonymousSupported;
        if(_.isBoolean(gameOptions.showSwitchGameMode)) {
            allowSwitchGameMode = gameOptions.showSwitchGameMode;
        } else {
            // as a workaround for now in Orbit we added allowSwitchGameMode read only property to gameInfo object
            // until we move all game logic to Orbit services
            const giAllowSwitchGameMode = gameOptions.gameInfo.allowSwitchGameMode;
            if(_.isBoolean(giAllowSwitchGameMode)) {
                allowSwitchGameMode = giAllowSwitchGameMode;
            }
        }
        return allowSwitchGameMode;
    }

    _extractGameNavbarLoginProps(gameOptions) {
        if(gameOptions.navbar) {
            return gameOptions.navbar.login;
        }

        return null;
    }
}